import makeCrud from '@/store/site/localization/crud'

// Stok hareketleri — salt-okunur (yalnızca listeleme kullanılır).
export default makeCrud('ecommerce_stock_movement')
